import FormControl from '@mui/joy/FormControl'
import FormLabel from '@mui/joy/FormLabel'
import { TextGrid } from './TextGrid'
import Textarea from '@mui/joy/Textarea'

export const PromptTextboxGrid = ({
    onFontChange,
    onFontSizeChange,
    onTextChange,
    onWeightChange,
    onTextAlignChange,
    onPromptChange,
    textObj,
}) => {
    const handlePromptChange = (e) => {
        onPromptChange({ obj: textObj, value: e.target.value })
    }
    return (
        <TextGrid
            onFontChange={onFontChange}
            onFontSizeChange={onFontSizeChange}
            onTextChange={onTextChange}
            onWeightChange={onWeightChange}
            onTextAlignChange={onTextAlignChange}
            textObj={textObj}
        >
            <FormControl>
                <FormLabel>Prompt</FormLabel>
                <Textarea
                    minRows={8}
                    maxRows={10}
                    defaultValue={textObj.prompt}
                    onChange={handlePromptChange}
                />
            </FormControl>
        </TextGrid>
    )
}
